import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c58b0f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-2 pb-4 mx-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_SetId = _resolveComponent("SetId", true)!
  const _component_BottomFormActionButtons = _resolveComponent("BottomFormActionButtons")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["set-id bg-background", { invisible: _ctx.isCameraActive }])
  }, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      証明書 - 身分証明書\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_StepBar, {
        maxValue: 4,
        currentValue: 1,
        class: "mb-4"
      }),
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, null, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_SetId, {
            modelValue: _ctx.inputValues,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues) = $event)),
            isCameraActive: _ctx.isCameraActive,
            "onUpdate:isCameraActive": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCameraActive) = $event))
          }, null, 8, ["modelValue", "isCameraActive"]),
          _createTextVNode(),
          _createVNode(_component_BottomFormActionButtons, {
            onSubmit: ($event: any) => (handleSubmit(_ctx.onClickSubmit)),
            hideSkipButton: ""
          }, null, 8, ["onSubmit"])
        ]),
        _: 1
      })
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ], 2))
}